/*
 *
 *  * Copyright (c) 2020 General Electric Company. All rights reserved.
 *  *
 *  * The copyright to the computer software herein is the property of
 *  * General Electric Company. The software may be used and/or copied only
 *  * with the written permission of General Electric Company or in accordance
 *  * with the terms and conditions stipulated in the agreement/contract
 *  * under which the software has been supplied.
 *
 */

import { ViewerContextItem } from '@app/di/data-model/viewer-context-item';
import { OnlineContextItem } from '@app/di/data-model/online-context-item';

export class ViewerContextInfo {
  currentIndex: number; // Holds current context item's index.
  contextItemList: Array<ViewerContextItem>; // Array of context item
  viewerContext: any; // Holds the viewer context
  discardFlag: boolean; // Holds the discard flag
  onlineContextItemList: Array<OnlineContextItem>; // online context array
  onlineContextIndex: number; // online context index
  studyClickTime: any; // Holds the study click time
  closeFlag: boolean; // Holds the close flag

  constructor() {
    this.currentIndex = -1; // Holds current context item's index.
    this.contextItemList = []; // Array of context item
    this.viewerContext = ''; // Holds the viewer context
    this.discardFlag = false; // Holds the discard flag
    this.onlineContextItemList = []; // online context array
    this.onlineContextIndex = -1; // online context index
    this.studyClickTime = 0; // Holds the study click time
    this.closeFlag = false; // Holds the close flag
  }
}
